import React, { forwardRef } from 'react';
import { IoMdInformationCircle } from "react-icons/io";
import MessageBox from '../../../components/MessageBox';
import MessageLabel from './MessageLabel';

const AdminCustomInput = forwardRef(({ previewFile, isReadonly, type, placeHolder, onChange, name, value, className, id, onBlur, onKeyDown, error, maxLength, noMargin, noBorder, appendText, accept, min, max, restrictNumberInput = false, ...rest }, ref) => {
    const handleChange = (e) => {
        const val = e.target.value;
        if (type === 'number' && restrictNumberInput) {
            if (val === '0' || (val.length > 1 && val.startsWith('0'))) {
                return;
            }
            if (val.length > 9) {
                return;
            }
            if (max !== undefined && !isNaN(val) && Number(val) > Number(max)) {
                return;
            }
        }
        if (val === '' || val.trim() !== '') {
            onChange?.(e);
        }
    };

    return (
        <div className='position-relative'>
            {type === "file" && previewFile && <MessageLabel text={previewFile} />}
            <input
                type={type || 'text'}
                name={name || ''}
                value={value || ''}
                onChange={handleChange}
                placeholder={placeHolder || 'fill the input'}
                ref={ref}
                onBlur={onBlur}
                onKeyDown={type === 'datetime-local' ? (e) => e.preventDefault() : onKeyDown}
                maxLength={maxLength}
                min={min}
                max={max}
                readOnly={isReadonly}
                accept={accept}
                id={id || "inputField"}
                data-test-id={id || "inputField"}
                {...rest}
                className={`custom-input ${appendText ? "append-text-padding" : ""} ${!noBorder ? 'custom-input-border' : ''} w-100 custom-placeholder bg-transparent theme-text-color ${className || ''} ${!noMargin ? "mb-3" : ""} ${error ? 'custom-input-error' : ''}`.trim()}
            />
            {appendText ? <span className='append-text'>{appendText}</span> : ""}
            {error && (
                <div className='d-flex align-items-center gap-1 mb-2'>
                    <IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} />
                    <MessageBox text={`${error}`} classname='errorred d-block' />
                </div>
            )}
        </div>
    );
});

export default AdminCustomInput;
